<div class="mb-1 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
  <p class="min-w-0 text-2xl font-bold leading-tight text-gray-900 sm:text-3xl">
    {{ pageTitle.title }}
  </p>

  <button
    *ngIf="pageTitle.showButton"
    routerLink="{{ pageTitle.buttonLink }}"
    type="button"
    class="inline-flex min-h-[44px] w-full shrink-0 items-center justify-center rounded-lg bg-white px-3 py-2.5 text-center text-sm font-medium text-gray-900 hover:bg-gray-200 focus:outline-none focus:ring-4 focus:ring-gray-100 sm:mb-0 sm:w-auto dark:focus:ring-gray-500"
  >
    <ng-icon name="{{ pageTitle.buttonIcon }}" class="mr-2"></ng-icon>

    {{ pageTitle.buttonText }}
  </button>
</div>

<hr class="my-4 h-px border-0 bg-gray-200 dark:bg-gray-700" />
